import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { WMS_STATUS } from "../../phan-he-nhap-kho/constants/constansNhapKho";
import { LOAI_PHIEU, TABLE_FIELD } from "../../utils/Constant";
import { formatDateToDDMMYYYY, formatMoney } from "../../utils/FormatUtils";
import { TongHopPhieuInterface } from "../TongHopPhieuModel";
import { Column } from "react-table";
import { columnNamesType, columnNamesTypeTableCollapse } from "@oceantech/oceantech-ui";


export const DanhSachPhieuColumns: ReadonlyArray<
  Column<TongHopPhieuInterface>
> = [
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="STT"
          className="text-center text-light max-w-35"
        />
      ),
      id: "stt",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={String(props?.row?.index + 1)}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="TT"
          className="text-center text-light max-w-35"
        />
      ),
      id: "custom",
      Cell: ({ ...props }) => (
        <div className="text-center">
          <i className="bi bi-circle-fill" style={{ color: props.data[props.row.index]?.color }}></i>
        </div>
      )
      ,
    },
    // {
    //   Header: (props) => (
    //     <TableCustomHeader<TongHopPhieuInterface>
    //       tableProps={props}
    //       title="Trạng thái"
    //       className="text-center text-white align-middle bg-pri min-w-80px"
    //     />
    //   ),
    //   id: "trangThai",
    //   Cell: ({ ...props }) => (
    //     <TableCustomCell
    //       className="text-left s-2"
    //       data={props.data[props.row.index]?.cabinetTypeName}
    //     />
    //   ),
    // },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Ngày tạo"
          className="text-center text-white align-middle bg-pri min-w-80px"
        />
      ),
      id: "createdDate",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center s-2"
          data={formatDateToDDMMYYYY(props.data[props.row.index]?.createdDate)}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Mã phiếu"
          className="text-center text-white align-middle bg-pri min-w-80px"
        />
      ),
      id: "code",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center s-2"
          data={props.data[props.row.index]?.code}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Nơi lập phiếu"
          className=" text-center text-white align-middle bg-pri min-w-40px"
        />
      ),
      id: "departmentName",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-left s-2"
          data={props.data[props.row.index]?.departmentName}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Trạng thái"
          className="text-center text-white align-middle bg-pri min-w-80px"
        />
      ),
      id: "statusName",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-left s-2"
          data={props.data[props.row.index]?.statusName}
        />
      ),
    },
  ];

export const DanhSachPhieuTongHopColumns: ReadonlyArray<
  Column<TongHopPhieuInterface>
> = [
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="STT"
          className="text-center text-light max-w-35"
        />
      ),
      id: "stt",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={String(props?.row?.index + 1)}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="TT"
          className="text-center text-light max-w-35"
        />
      ),
      id: "custom",
      Cell: ({ ...props }) => (
        <div className="text-center">
          <i className="bi bi-circle-fill" style={{ color: props.data[props.row.index]?.color }}></i>
        </div>
      )
      ,
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Ngày lĩnh"
          className="text-center text-white align-middle bg-pri min-w-60px"
        />
      ),
      id: "createdDatee",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={formatDateToDDMMYYYY(props.data[props.row.index]?.createdDate)}
        />
      ),
    },
        {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Ngày xuất"
          className="text-center text-white align-middle bg-pri min-w-60px"
        />
      ),
      id: "exportDate",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={formatDateToDDMMYYYY(props.data[props.row.index]?.exportDate)}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Ngày tạo"
          className="text-center text-white align-middle bg-pri min-w-40px"
        />
      ),
      id: "createdDate",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center s-2"
          data={formatDateToDDMMYYYY(props.data[props.row.index]?.createdDate)}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Mã phiếu"
          className="text-center text-white align-middle bg-pri min-w-80px"
        />
      ),
      id: "code",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center s-2"
          data={props.data[props.row.index]?.code}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Tên phiếu"
          className="text-center text-white align-middle bg-pri min-w-100px"
        />
      ),
      id: "name",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-left s-2"
          data={props.data[props.row.index]?.name}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Người duyệt"
          className="text-center text-white align-middle bg-pri min-w-100px"
        />
      ),
      id: "duyet",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-left s-2"
          data={props.data[props.row.index]?.duyet}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Khoa/phòng"
          className="text-center text-white align-middle bg-pri min-w-120px"
        />
      ),
      id: "departmentName",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-left s-2"
          data={props.data[props.row.index]?.departmentName}
        />
      ),
    },
    {
      Header: (props) => (
        <TableCustomHeader<TongHopPhieuInterface>
          tableProps={props}
          title="Kho"
          className="text-center text-white align-middle bg-pri min-w-120px"
        />
      ),
      id: "mateWhName",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-left s-2"
          data={props.data[props.row.index]?.mateWhName}
        />
      ),
    },
  ];

export const ColumnsDanhSachPhieu: columnNamesTypeTableCollapse[] = [
  {
    name: "TT",
    field: TABLE_FIELD.TT,
    headerStyle: { width: 0 },
    render: (row: any) => row?.color && <i className="bi bi-circle-fill" style={{ color: row?.color }}></i>
  },
  {
    name: "Mã thuốc",
    field: "itemCode",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Tên thuốc",
    field: "itemName",
    headerStyle: {
      minWidth: "200px"
    },
    isCollapse: true,
  },
  {
    name: "Số lượng",
    field: "totalQuantity",
    headerStyle: {
      minWidth: "80px",
    },
    cellStyle: {
      textAlign: 'end',
    },
  },
  {
    name: "Đơn vị",
    field: "unitOfMeasureName",
    headerStyle: {
      minWidth: "105px"
    },
  },
  {
    name: "Liều dùng",
    field: "usageIns",
    headerStyle: {
      minWidth: "105px"
    },
  },
  {
    name: "Cách dùng",
    field: "usageIns",
    headerStyle: {
      minWidth: "200px"
    },
  },
  {
    name: "Số lô",
    field: "consignment",
    headerStyle: {
      minWidth: "75px"
    },
    render: (row, index, stt) => row?.consignment || row?.item?.consignment,
  },
  {
    name: "Hạn sử dụng",
    field: "expiryDate",
    headerStyle: {
      minWidth: "100px"
    },
    render: (row, index, stt) => formatDateToDDMMYYYY(row?.expiryDate || row?.item?.expiryDate),
  },
  // {
  //   name: "Khoa/phòng",
  //   field: "khoa",
  //   headerStyle: {
  //     minWidth: "200px"
  //   },
  // },
  // {
  //   name: "Kho",
  //   field: "mateWhName",
  //   headerStyle: {
  //     minWidth: "200px"
  //   },
  // },
]

export const columnsBn: columnNamesTypeTableCollapse[] = [
  {
    name: "Mã thuốc",
    field: "itemCode",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Tên thuốc",
    field: "itemName",
    headerStyle: {
      minWidth: "200px"
    },
    isCollapse: true,
  },
  {
    name: "Số lượng",
    field: "totalQuantity",
    headerStyle: {
      minWidth: "80px",
    },
    cellStyle: {
      textAlign: 'end',
    },
  },
  {
    name: "Đơn vị",
    field: "unitOfMeasureName",
    headerStyle: {
      minWidth: "105px"
    },
  },
  {
    name: "Hướng dẫn sử dụng",
    field: "usageIns",
    headerStyle: {
      minWidth: "200px"
    },
  },
  {
    name: "Liều dùng",
    field: "usageInss",
    headerStyle: {
      minWidth: "200px"
    },
  },
  // {
  //   name: "Giá bán",
  //   field: "salePrice",
  //   headerStyle: {
  //     minWidth: "100px"
  //   },
  //   cellStyle: {
  //     textAlign: 'end',
  //   },
  //   render: (row, index, stt) => formatMoney(row?.salePrice || row?.item?.salePrice),
  // },
  // {
  //   name: "Thành tiền",
  //   field: "totalAmount",
  //   headerStyle: {
  //     minWidth: "100px"
  //   },
  //   cellStyle: {
  //     textAlign: 'end',
  //   },
  //   render: (row, index, stt) => {
  //     const quantity = parseFloat(row?.totalQuantity || row?.item?.totalQuantity || 0);
  //     const price = parseFloat(row?.salePrice || row?.item?.salePrice || 0);
  //     const vat = parseFloat(row?.vat || row?.item?.vat || 0);
  //     const result = (quantity * price * (1 + vat / 100));
  //     return formatMoney(result);
  //   },
  // },
  {
    name: "Số lô",
    field: "consignment",
    headerStyle: {
      minWidth: "75px"
    },
    render: (row, index, stt) => row?.consignment || row?.item?.consignment,
  },
  {
    name: "Hạn sử dụng",
    field: "expiryDate",
    headerStyle: {
      minWidth: "120px"
    },
    render: (row, index, stt) => formatDateToDDMMYYYY(row?.expiryDate || row?.item?.expiryDate),
  },
]

export const HoanTraColumnsTableCustom = ( customComponent?: any, propsCustomComponent?: any): any[] => {
  let result: any[] = [
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="STT"
          className="text-center text-light max-w-35"
        />
      ),
      id: "stt",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={String(props?.row?.index + 1)}
        />
      ),
    },
        {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Mã thuốc bệnh viện"
          className="text-center text-light max-w-35"
        />
      ),
      id: "codebv",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={props.data[props.row.index]?.code}
        />
      ),
    },
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Mã thuốc"
          className="text-center text-light max-w-35"
        />
      ),
      id: "code",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
          data={props.data[props.row.index]?.code}
        />
      ),
    },
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Tên thuốc"
          className="text-center text-light max-w-35"
        />
      ),
      id: "itemName",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
            data={props.data[props.row.index]?.itemName}
        />
      ),
    },
     {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Đơn"
          className="text-center text-light max-w-35"
        />
      ),
      id: "don",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
             data={props.data[props.row.index]?.don}
        />
      ),
    },
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Số lượng"
          className="text-center text-light max-w-35"
        />
      ),
      id: "requireQuantity",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
             data={props.data[props.row.index]?.requireQuantity}
        />
      ),
    },
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title={propsCustomComponent?.title}
          className="text-center text-light max-w-35"
        />
      ),
      id: "totalquantity",
      Cell: ({ ...props }) => customComponent({ ...props, ...propsCustomComponent })
    },
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="Số lô"
          className="text-center text-light max-w-35"
        />
      ),
      id: "consignment",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
             data={props.data[props.row.index]?.consignment}
        />
      ),
    },
    {
      Header: (props: any) => (
        <TableCustomHeader<any>
          tableProps={props}
          title="HSD"
          className="text-center text-light max-w-35"
        />
      ),
      id: "expiryDate",
      Cell: ({ ...props }) => (
        <TableCustomCell
          className="text-center "
             data={props.data[props.row.index]?.expiryDate}
        />
      ),
    },
  ];



  return result;
};